import React, { FC, useEffect } from "react";
import { IMAGE_URL_CONFIG } from "../../../../constants/url";

interface IRefundConfirmationHeaderProps { }

const RefundConfirmationHeader: FC<IRefundConfirmationHeaderProps> = () => {
  return (
    <div className="refund-wrapper">
      <div className="col-12 px-2">
        <div className="refund-header">
          <img
            src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'tick_circle.svg'}
            alt="success"
            style={{
              width: '24px',
              height: '24px'
            }}
            className=""
          />
          <p>Your refund has been successfully processed.</p>
        </div>
      </div>
    </div>
  );
};

export default RefundConfirmationHeader;
